import { useHandlerWhenClickedOutside } from '@hooks';
import upperFirst from 'lodash/upperFirst';
import React from 'react';
import { useIntl } from 'react-intl';

import { useMediaQuery } from '@hooks/useMediaQuery';
import { smallScreen } from '@styles/constants';

import { Overlay } from '@components/organisms/Overlay';
import { AttributeTypeFilterInput } from './AttributeTypeFilterInput';
import * as S from './styles';
import { IProps } from './types';

export const FilterSidebar: React.FC<IProps> = ({
  hide,
  filters,
  show,
  attributes,
  target,
  onFiltersChange,
  clearFilters,
  activeFilters,
}: IProps) => {
  const intl = useIntl();
  const { setElementRef } = useHandlerWhenClickedOutside(() => {
    hide();
  });

  const [isSmallScreen] = useMediaQuery(`(max-width: ${smallScreen}px)`);

  const filtersJsx = (
    <S.Wrapper ref={setElementRef()} data-cy="filter-sidebar">
      <S.CloseButton onClick={hide} type="button" />
      <S.Header>
        <span>
          {intl.formatMessage({
            defaultMessage: 'FILTERS',
            id: 'uqEtJ1',
          })}
        </span>
        <S.ActiveFilters>
          <span>{activeFilters}</span>
        </S.ActiveFilters>
      </S.Header>
      {attributes &&
        attributes.map(
          ({ id, name, slug, values, translation, choiceType }) => {
            const title = upperFirst(translation?.name || name || slug).replace(
              '-',
              ' '
            );

            return (
              <S.FilterGroup key={id}>
                <S.FilterTitle>{title}</S.FilterTitle>
                <AttributeTypeFilterInput
                  choiceType={choiceType}
                  onFiltersChange={onFiltersChange}
                  filters={filters}
                  values={values}
                  slug={slug}
                />
              </S.FilterGroup>
            );
          }
        )}
      <S.ButtonFilterGroup>
        {/*
        <S.DoneButton className="red-dot" onClick={hide}>
          {intl.formatMessage({
            defaultMessage: 'Done',
            id: 'JXdbo8',
          })}
        </S.DoneButton>
        */}
        <S.ClearButton type="button" onClick={clearFilters}>
          {intl.formatMessage({
            defaultMessage: 'Reset filters',
            id: 'jZ0o74',
          })}
        </S.ClearButton>
      </S.ButtonFilterGroup>
    </S.Wrapper>
  );

  return isSmallScreen ? (
    <Overlay
      duration={0}
      position="bottom"
      show={show}
      hide={hide}
      target={target}
    >
      {filtersJsx}
    </Overlay>
  ) : (
    <Overlay
      duration={0}
      position="left"
      show={show}
      hide={hide}
      target={target}
    >
      {filtersJsx}
    </Overlay>
  );
};

FilterSidebar.displayName = 'FilterSidebar';
